import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import estbn from '../assets/images/ESTBN.png'
import esCircle from "../assets/images/Smoll_ESTBN_Logo.png";
import {
  FaCalendarAlt,
  FaCogs,
  FaBell,
  FaSignOutAlt,
  FaUsers,
  FaTruck,
  FaClipboardList,
  FaTools,
  FaUserShield,
  FaWarehouse,
  FaArrowRight,
  FaArrowLeft,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import "./Sidenav.css";
import { EmojiEvents, MiscellaneousServices, Percent } from "@mui/icons-material";
import { useSidebar } from "./SidebarProvider";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/apicalls/authApiCall"; 
import { useNavigate } from "react-router-dom";
import {
  CalendarCheck,
  ChevronDown,
  ChevronUp,
  FileQuestion,
  Gift,
  History,
  Package,
  Ticket,
  Truck,
  User,
  Wrench,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase"; 

const SideNav = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = { Authorization: `Bearer ${token}` };

  const isDriver = user?.stuff?.roles[0].name === "driver";

  const isEngineer = user?.stuff?.roles[0].name === "engineer";

  const [openMenus, setOpenMenus] = useState({});

  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const stuffMenuItems = [
    { name: "الصفحة الرئيسية", icon: <MdDashboard />, path: "/Home" },
    { name: "طلبات اليوم", icon: <CalendarCheck />, path: "/dayOrders" },
    {
      name: "بيانات و فحص السيارة",
      icon: <Truck />,
      path: "/checkCar",
    },
    { name: "طلب مساعدة علي الطريق", icon: <FileQuestion />, path: "/sos" },
    {
      name: "سجل الرحلات السابقة",
      icon: <History />,
      path: "/trips",
    },
    {
      name: "الصفحة الشخصية",
      icon: <User />,
      path: "/profile",
    },
    { name: "الخروج", icon: <FaSignOutAlt />, path: "/logout" },
  ];

  const engineerMenuItems = [
    { name: "الصفحة الرئيسية", icon: <MdDashboard />, path: "/Home" },
    { name: "طلبات اليوم", icon: <CalendarCheck />, path: "/ordersExecution" },
    {
      name: "بيانات و فحص الادوات",
      icon: <Wrench />,
      path: "/checkingtools",
    },
    {
      name: "المواد المطلوبة",
      icon: <FaCalendarAlt />,
      path: "/ordersProductsCheck",
    },
    { name: "طلب مساعدة علي الطريق", icon: <FileQuestion />, path: "/sos" },
    {
      name: "سجل الطلبات",
      icon: <History />,
      path: "/ordersHistory",
    },
    {
      name: "الصفحة الشخصية",
      icon: <User />,
      path: "/profile",
    },
    { name: "الخروج", icon: <FaSignOutAlt />, path: "/logout" },
  ];

  const menuItems = [
    { name: "Dashboard", icon: <MdDashboard />, path: "/dashboard" },
    { name: "Orders", icon: <FaClipboardList />, path: "/orders" },
    { name: "Clients", icon: <FaUsers />, path: "/clients" },
    {
      name: "Incentives",
      icon: <Gift />,
      children: [
        { name: "Overview", path: "/overView" },
        { name: "All Incentives", path: "/incentives" },
      ],
    },
    {
      name: "Vehicles",
      icon: <FaTruck />,
      children: [
        { name: "Doorstep Vehicles", path: "/vehicles" },
        { name: "Categories", path: "/vehiclesCategories" },
      ],
    },
    { name: "Calendar", icon: <FaCalendarAlt />, path: "/calendar" },
    {
      name: "Staff",
      icon: <FaUserShield />,
      children: [
        { name: "Operation", path: "/operation" },
        { name: "Technical", path: "/staff" },
        { name: "Expenses", path: "/expenses" },
        { name: "Notes", path: "/notes" },
        { name: "Sos", path: "/sosRequests", badge: "sos" },
      ],
    },
    {
      name: "User Requests  ",
      icon: <FaUserShield />,
      children: [
        { name: "Maintenance", path: "/maintenance", badge: "maintenance" },
        { name: "Other Services", path: "/requests", badge: "otherServices" },
        { name: "Help Requests", path: "/helpRequests", badge: "helpRequests" },
      ],
    },
    { name: "Offers", icon: <Percent />, path: "/offers" },
    { name: "Bundles", icon: <Package />, path: "/bundles" },
    { name: "Coupons", icon: <Ticket />, path: "/coupons" },
    { name: "Reward System", icon: <EmojiEvents />, path: "/Rewards" },
    {
      name: "Stock",
      icon: <FaWarehouse />,
      children: [
        { name: "Categories", path: "/Categories" },
        { name: "Brands", path: "/Brands" },
        {
          name: "Manufacturers",
          path: "/manufacturers",
        },
        { name: "Products List", path: "/stock" },
        { name: "Vendors", path: "/stock/vendors" },
      ],
    },
    {
      name: "Notification",
      icon: <FaBell />,
      children: [
        { name: "Dashboard", path: "/NotifcationsDashboard" },
        { name: "Templates", path: "/Templates" },
        { name: "Categories", path: "/Notification Categories" },
        { name: "Campaigns", path: "/notificationCampaigns" },
        { name: "Automated Notify", path: "/AutomatedNotification" },
        { name: "User Groups", path: "/Usergroup" },
        { name: "Targeting Rules", path: "/targetingRules" },
        { name: "Circuit Breakers", path: "/CircuitBreakers" },
      ],
    },
    { name: "Equipments", icon: <FaTools />, path: "/equipments" },
    { name: "Services", icon: <MiscellaneousServices />, path: "/services" },
    { name: "Authorization", icon: <FaUserShield />, path: "/permissions" },
    { name: "Settings", icon: <FaCogs />, path: "/settings" },
    { name: "Log Out", icon: <FaSignOutAlt />, path: "/logout" },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleMenu = (index) => {
    setOpenMenus((prev) => {
      const closed = {};

      closed[index] = !prev[index];

      return closed;
    });

    setActiveIndex(index);
  };

  const isChildActive = (children) => {
    return children?.some((child) => location.pathname === child.path);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    menuItems.forEach((item, index) => {
      if (item.children && isChildActive(item.children)) {
        setOpenMenus((prev) => ({
          ...prev,
          [index]: true,
        }));
      }
    });
  }, [location.pathname]);

  const currentMenu = isEngineer ? engineerMenuItems : stuffMenuItems;

  useEffect(() => {
    const currentIndex = currentMenu.findIndex(
      (item) => item.path === location.pathname,
    );
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
    }
  }, [location.pathname, isEngineer]);

  // *************** firebase *****************
const [unreadCounts, setUnreadCounts] = useState({
  sos: 0,
  maintenance: 0,
  otherServices: 0,
  helpRequests: 0,
});

const prevCountsRef = useRef(null);

const [animatingBadges, setAnimatingBadges] = useState(new Set()); 
const [animatingParents, setAnimatingParents] = useState(new Set());
const badgeTimersRef = useRef({});

const triggerAnimation = (changedKeys) => {
  changedKeys.forEach((k) => {
    if (badgeTimersRef.current[k]) {
      clearTimeout(badgeTimersRef.current[k]);
    }
  });

  setAnimatingBadges((prev) => {
    const next = new Set(prev);
    changedKeys.forEach((k) => next.add(k));
    return next;
  });

  const affectedParentIndexes = new Set();
  menuItems.forEach((item, index) => {
    if (item.children?.some((c) => c.badge && changedKeys.includes(c.badge))) {
      affectedParentIndexes.add(index);
    }
  });

  setAnimatingParents(affectedParentIndexes);

  const timer = setTimeout(() => {
    setAnimatingBadges(new Set());
    setAnimatingParents(new Set());
    changedKeys.forEach((k) => {
      delete badgeTimersRef.current[k];
    });
  }, 60000); 

  changedKeys.forEach((k) => {
    badgeTimersRef.current[k] = timer;
  });
};

const applyNewCounts = (newCounts) => {
  if (prevCountsRef.current === null) {
    const saved = localStorage.getItem("unreadCounts");
    prevCountsRef.current = saved ? JSON.parse(saved) : newCounts;
  }

  const changed = Object.keys(newCounts).filter(
    (k) => newCounts[k] !== prevCountsRef.current[k],
  );
  
  prevCountsRef.current = { ...newCounts };
  localStorage.setItem("unreadCounts", JSON.stringify(newCounts));
  setUnreadCounts(newCounts);
  if (changed.length > 0) triggerAnimation(changed);
};
  
useEffect(() => {
  if (!token) return;
  axios
    .get(`${newBaseUrl}/api/portal/unread-count`, { headers })
    .then((res) => {
      const d = res.data;
      const newCounts = {
        sos: d.unread_count || 0,
        maintenance: d.unread_price_plan_request_count || 0,
        otherServices: d.unread_other_request_count || 0,
        helpRequests: d.unread_help_count || 0,
      };
      applyNewCounts(newCounts);
    })
    .catch(console.error);
}, [token]);

useEffect(() => {
  if (!token) return;
  const unreadRef = ref(database, "unread_count");
  const unsubscribe = onValue(unreadRef, () => {
    axios
      .get(`${newBaseUrl}/api/portal/unread-count`, { headers })
      .then((res) => {
        const d = res.data;
        const newCounts = {
          sos: d.unread_count || 0,
          maintenance: d.unread_price_plan_request_count || 0,
          otherServices: d.unread_other_request_count || 0,
          helpRequests: d.unread_help_count || 0,
        };
        applyNewCounts(newCounts);
      })
      .catch(console.error);
  });
  return () => unsubscribe();
}, [token]);

const Badge = ({ count, isAnimating, onClear }) => {
  if (!count || count === 0) return null;
  return (
    <span
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClear?.();
      }}
      className={isAnimating ? "badge-animated" : "badge-default"}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};

  // *************** firebase ******************

  return (
    <div>
      <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <div
          className={isSidebarOpen ? "arrow-close-toggle" : "arrow-open-toggle"}
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? (
            <FaArrowLeft style={{ fontSize: "12px" }} />
          ) : (
            <FaArrowRight style={{ fontSize: "12px" }} />
          )}
        </div>
        <div className="sidebar-header" onClick={toggleSidebar}>
          <img
            src={isSidebarOpen ? estbn : esCircle}
            alt="Logo"
            className={isSidebarOpen ? "sideNav-logo" : "sideNav-close-logo"}
          />
        </div>
        {isDriver ? (
          <ul className="sidebar-menu" style={{ direction: "rtl" }}>
            {stuffMenuItems.map((item, index) => {
              if (item.children) {
                const isOpen = openMenus[index];
                return (
                  <li
                    key={index}
                    className={`sidebar-item nested${
                      animatingParents.has(index)
                        ? isSidebarOpen
                          ? " parent-flash"
                          : " parent-flash-closed"
                        : ""
                    }`}
                  >
                    {/* Main Item */}
                    <div
                      className={`sidebar-link submenu-header ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      onClick={() => toggleMenu(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="submenu-main">
                        <span
                          className={`sideNav-icon${
                            !isSidebarOpen && animatingParents.has(index)
                              ? " icon-pulse"
                              : ""
                          }`}
                        >
                          {item.icon}
                        </span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>

                      {/* Arrow */}
                      {isSidebarOpen && (
                        <span className="submenu-arrow">
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      )}
                    </div>

                    {/* Sub Menu */}
                    {isSidebarOpen && isOpen && (
                      <ul className="sideNav-nested-menu">
                        {item.children.map((child, i) => (
                          <li
  key={i}
  className={child.badge && animatingBadges.has(child.badge) ? "nested-item-flash" : ""}
>
                            <NavLink
                              to={child.path}
                              className="nested-link"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                setActiveIndex(index);
                                setOpenMenus({ [index]: true });
                                // كليرها لما يضغط
                                if (child.badge) {
                                  setAnimatingBadges((prev) => {
                                    const next = new Set(prev);
                                    next.delete(child.badge);
                                    return next;
                                  });
                                  setAnimatingParents((prev) => {
                                    const next = new Set(prev);
                                    next.delete(index);
                                    return next;
                                  });
                                }
                              }}
                            >
                              <span className="dot">•</span>
                              <span style={{ flex: 1 }}>{child.name}</span>
                              {child.badge && (
                                <Badge
                                  count={unreadCounts[child.badge]}
                                  isAnimating={animatingBadges.has(child.badge)}
                                  onClear={() => {
                                    setAnimatingBadges((prev) => {
                                      const next = new Set(prev);
                                      next.delete(child.badge);
                                      return next;
                                    });
                                  }}
                                />
                              )}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }
              if (item.name === "الخروج") {
                return (
                  <li key={index} className="sidebar-item">
                    <NavLink
                      to="/login"
                      className={`sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      title={!isSidebarOpen ? item.name : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(logoutUser());
                        navigate("/login");
                      }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  </li>
                );
              }
              return (
                <li key={index} className="sidebar-item">
                  <NavLink
                    to={item.path}
                    className={() =>
                      `sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`
                    }
                    onClick={() => {
                      setActiveIndex(index);
                      setOpenMenus({});
                    }}
                    title={!isSidebarOpen ? item.name : ""}
                  >
                    <div className="submenu-main">
                      <span className="sideNav-icon">{item.icon}</span>

                      {isSidebarOpen && (
                        <span
                          className="sideNav-label text-ellipsis"
                          title={item.name}
                        >
                          {item.name}
                        </span>
                      )}
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        ) : isEngineer ? (
          <ul className="sidebar-menu" style={{ direction: "rtl" }}>
            {engineerMenuItems.map((item, index) => {
              if (item.children) {
                const isOpen = openMenus[index];
                return (
                 <li
  key={index}
  className={`sidebar-item nested${
    animatingParents.has(index) ? (isSidebarOpen ? " parent-flash" : " parent-flash-closed") : ""
  }`}
>
                    {/* Main Item */}
                    <div
                      className={`sidebar-link submenu-header ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      onClick={() => toggleMenu(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="submenu-main">
                 <span
  className={`sideNav-icon${
    !isSidebarOpen && animatingParents.has(index) ? " icon-pulse" : ""
  }`}
>
  {item.icon}
</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>

                      {/* Arrow */}
                      {isSidebarOpen && (
                        <span className="submenu-arrow">
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      )}
                    </div>

                    {/* Sub Menu */}
                    {isSidebarOpen && isOpen && (
                      <ul className="sideNav-nested-menu">
                        {item.children.map((child, i) => (
                          <li
  key={i}
  className={child.badge && animatingBadges.has(child.badge) ? "nested-item-flash" : ""}
>
                            <NavLink
                              to={child.path}
                              className="nested-link"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                              onClick={() => {
                                setActiveIndex(index);
                                setOpenMenus({ [index]: true });
                                // كليرها لما يضغط
                                if (child.badge) {
                                  setAnimatingBadges((prev) => {
                                    const next = new Set(prev);
                                    next.delete(child.badge);
                                    return next;
                                  });
                                  setAnimatingParents((prev) => {
                                    const next = new Set(prev);
                                    next.delete(index);
                                    return next;
                                  });
                                }
                              }}
                            >
                              <span className="dot">•</span>
                              <span style={{ flex: 1 }}>{child.name}</span>
                              {child.badge && (
                                <Badge
                                  count={unreadCounts[child.badge]}
                                  isAnimating={animatingBadges.has(child.badge)}
                                  onClear={() => {
                                    setAnimatingBadges((prev) => {
                                      const next = new Set(prev);
                                      next.delete(child.badge);
                                      return next;
                                    });
                                  }}
                                />
                              )}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }
              if (item.name === "الخروج") {
                return (
                  <li key={index} className="sidebar-item">
                    <NavLink
                      to="/login"
                      className={`sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      title={!isSidebarOpen ? item.name : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(logoutUser());
                        navigate("/login");
                      }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  </li>
                );
              }
              return (
                <li key={index} className="sidebar-item">
                  <NavLink
                    to={item.path}
                    className={() =>
                      `sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`
                    }
                    onClick={() => {
                      setActiveIndex(index);
                      setOpenMenus({});
                    }}
                    title={!isSidebarOpen ? item.name : ""}
                  >
                    <div className="submenu-main">
                      <span className="sideNav-icon">{item.icon}</span>

                      {isSidebarOpen && (
                        <span
                          className="sideNav-label text-ellipsis"
                          title={item.name}
                        >
                          {item.name}
                        </span>
                      )}
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        ) : (
          <ul className="sidebar-menu">
            {menuItems.map((item, index) => {
              if (item.children) {
                const isOpen = openMenus[index];
                return (
                  <li
                    key={index}
                    className={`sidebar-item nested${
                      animatingParents.has(index)
                        ? isSidebarOpen
                          ? " parent-flash"
                          : " parent-flash-closed"
                        : ""
                    }`}
                  >
                    {/* Main Item */}
                    <div
                      className={`sidebar-link submenu-header ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      onClick={() => toggleMenu(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="submenu-main">
                        <span
                          className={`sideNav-icon${
                            !isSidebarOpen && animatingParents.has(index)
                              ? " icon-pulse"
                              : ""
                          }`}
                        >
                          {item.icon}
                        </span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>

                      {/* Arrow */}
                      {isSidebarOpen && (
                        <span className="submenu-arrow">
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      )}
                    </div>
                    {/* Sub Menu */}
                    {isSidebarOpen && isOpen && (
                      <ul className="sideNav-nested-menu">
                        {item.children.map((child, i) => (
                          <li
  key={i}
  className={child.badge && animatingBadges.has(child.badge) ? "nested-item-flash" : ""}
>
                            <NavLink
                              to={child.path}
                              className="nested-link"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                              onClick={() => {
                                setActiveIndex(index);
                                setOpenMenus({ [index]: true });
                                // كليرها لما يضغط
                                if (child.badge) {
                                  setAnimatingBadges((prev) => {
                                    const next = new Set(prev);
                                    next.delete(child.badge);
                                    return next;
                                  });
                                  setAnimatingParents((prev) => {
                                    const next = new Set(prev);
                                    next.delete(index);
                                    return next;
                                  });
                                }
                              }}
                            >
                              <span className="dot">•</span>
                              <span style={{ flex: 1 }}>{child.name}</span>
                              {child.badge && (
                                <Badge
                                  count={unreadCounts[child.badge]}
                                  isAnimating={animatingBadges.has(child.badge)}
                                  onClear={() => {
                                    setAnimatingBadges((prev) => {
                                      const next = new Set(prev);
                                      next.delete(child.badge);
                                      return next;
                                    });
                                  }}
                                />
                              )}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }
              if (item.name === "Log Out") {
                return (
                  <li key={index} className="sidebar-item">
                    <NavLink
                      to="/login"
                      className={`sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      title={!isSidebarOpen ? item.name : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(logoutUser());
                        navigate("/login");
                      }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  </li>
                );
              }
              return (
                <li key={index} className="sidebar-item">
                  <NavLink
                    to={item.path}
                    className={() =>
                      `sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`
                    }
                    onClick={() => {
                      setActiveIndex(index);
                      setOpenMenus({});
                    }}
                    title={!isSidebarOpen ? item.name : ""}
                  >
                    <div className="submenu-main">
                      <span className="sideNav-icon">{item.icon}</span>

                      {isSidebarOpen && (
                        <span
                          className="sideNav-label text-ellipsis"
                          title={item.name}
                        >
                          {item.name}
                        </span>
                      )}
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};;

export default SideNav;

